module.exports = __webpack_public_path__ + "static/media/info-icon-dual-tone.46236c04.svg";